import { Typography as T } from "@mui/material";

type Props = {
  labelErrorText: string;
};
const LabelError = ({ labelErrorText }: Props) => {
  return (
    <T variant="labelErrorText">{labelErrorText || "The field is required"}</T>
  );
};

export { LabelError };
